"use strict";

var _regeneratorRuntime = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _defineProperty = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/defineProperty.js");

var _classCallCheck = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var firestore_1 = require("firebase/firestore");

var storage_1 = require("firebase/storage");

var nanoid_1 = require("nanoid");

var firebase_1 = require("../../config/firebase");

var Espace_1 = __importDefault(require("../Model/Espace"));

var Media = /*#__PURE__*/function (_Espace_1$default) {
  _inherits(Media, _Espace_1$default);

  var _super = _createSuper(Media);

  function Media(props) {
    _classCallCheck(this, Media);

    return _super.call(this, _objectSpread(_objectSpread({}, props), {}, {
      collectionName: 'medias',
      orderDirection: (props === null || props === void 0 ? void 0 : props.orderDirection) || 'desc',
      orderField: (props === null || props === void 0 ? void 0 : props.orderField) || 'createdAt'
    }));
  }

  _createClass(Media, [{
    key: "uploadFile",
    value: function () {
      var _uploadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(image) {
        var _a, _b, _c, extension, path, storageRef, snapshot, _snapshot$metadata, bucket, fullPath, size, data, docRef;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                extension = (_c = (_a = image.name) === null || _a === void 0 ? void 0 : _a.split('.')[((_b = image.name) === null || _b === void 0 ? void 0 : _b.split('.').length) - 1].toLowerCase()) !== null && _c !== void 0 ? _c : 'jpeg';
                path = "".concat(this.espaceId, "/").concat((0, nanoid_1.nanoid)(), ".").concat(extension);
                console.info('path', path);
                storageRef = (0, storage_1.ref)(firebase_1.storage, path);
                _context.next = 6;
                return (0, storage_1.uploadBytes)(storageRef, image);

              case 6:
                snapshot = _context.sent;
                console.info('snapshot.metadata', snapshot);
                console.info('image', image);

                if (snapshot) {
                  _context.next = 11;
                  break;
                }

                throw new Error("probleme lors de l'enregistrement du fichier dans le bucket");

              case 11:
                _snapshot$metadata = snapshot.metadata, bucket = _snapshot$metadata.bucket, fullPath = _snapshot$metadata.fullPath, size = _snapshot$metadata.size;
                data = this.clean({
                  bucket: bucket,
                  fullPath: fullPath,
                  size: size,
                  lastModified: image.lastModified,
                  name: image.name,
                  type: image.type
                }, true);
                docRef = (0, firestore_1.doc)(this.getCollectionRef());
                (0, firestore_1.setDoc)(docRef, data);
                return _context.abrupt("return", (0, firestore_1.getDoc)(docRef).then(function (s) {
                  return _objectSpread({
                    id: docRef.id
                  }, s.data());
                }));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function uploadFile(_x) {
        return _uploadFile.apply(this, arguments);
      }

      return uploadFile;
    }()
  }, {
    key: "uploadUrl",
    value: function () {
      var _uploadUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(str) {
        var _a, url, extension, path, image, storageRef, snapshot, _snapshot$metadata2, bucket, fullPath, size, data, docRef;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                url = new URL(str);
                _context2.next = 7;
                break;

              case 4:
                _context2.prev = 4;
                _context2.t0 = _context2["catch"](0);
                throw new Error("le chemin n'est pas une url valide");

              case 7:
                console.info('url', url);

                if (!(url.protocol !== 'http:' && url.protocol !== 'https:')) {
                  _context2.next = 10;
                  break;
                }

                throw new Error("le chemin n'est pas une url valide");

              case 10:
                extension = (_a = url.pathname.split('.')[url.pathname.split('.').length - 1].toLowerCase()) !== null && _a !== void 0 ? _a : 'jpeg';
                path = "".concat(this.espaceId, "/").concat((0, nanoid_1.nanoid)(), ".").concat(extension);
                _context2.next = 14;
                return fetch(str).then(function (r) {
                  return r.blob();
                });

              case 14:
                image = _context2.sent;

                if (image) {
                  _context2.next = 17;
                  break;
                }

                throw new Error("le fichier n'existe pas");

              case 17:
                console.info('image', image);
                storageRef = (0, storage_1.ref)(firebase_1.storage, path);
                _context2.next = 21;
                return (0, storage_1.uploadBytes)(storageRef, image);

              case 21:
                snapshot = _context2.sent;
                console.info('snapshot.metadata', snapshot);
                console.info('url', url);

                if (snapshot) {
                  _context2.next = 26;
                  break;
                }

                throw new Error("probleme lors de l'enregistrement du fichier dans le bucket");

              case 26:
                _snapshot$metadata2 = snapshot.metadata, bucket = _snapshot$metadata2.bucket, fullPath = _snapshot$metadata2.fullPath, size = _snapshot$metadata2.size;
                data = this.clean({
                  bucket: bucket,
                  fullPath: fullPath,
                  size: size,
                  name: str,
                  type: image.type
                }, true);
                docRef = (0, firestore_1.doc)(this.getCollectionRef());
                (0, firestore_1.setDoc)(docRef, data);
                return _context2.abrupt("return", (0, firestore_1.getDoc)(docRef).then(function (s) {
                  return _objectSpread({
                    id: docRef.id
                  }, s.data());
                }));

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 4]]);
      }));

      function uploadUrl(_x2) {
        return _uploadUrl.apply(this, arguments);
      }

      return uploadUrl;
    }()
  }, {
    key: "deletePhoto",
    value: function () {
      var _deletePhoto = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(fullPath) {
        var constraints, q, querySnapshot;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                constraints = [(0, firestore_1.where)('fullPath', '==', fullPath)];

                if (this.espaceId) {
                  constraints.push((0, firestore_1.where)('boutique', '==', this.espaceId));
                }

                q = (0, firestore_1.query).apply(void 0, [this.getCollectionRef()].concat(constraints));
                _context3.next = 5;
                return (0, firestore_1.getDocs)(q);

              case 5:
                querySnapshot = _context3.sent;

                if (!(!querySnapshot.empty && 1 === querySnapshot.size)) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return", (0, firestore_1.deleteDoc)(querySnapshot.docs[0].ref));

              case 8:
                throw new Error("La photo n'existe pas");

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deletePhoto(_x3) {
        return _deletePhoto.apply(this, arguments);
      }

      return deletePhoto;
    }()
  }, {
    key: "watchNotUse",
    value: function watchNotUse(_next, options) {
      var constraints = [(0, firestore_1.where)('docId', '==', ''), (0, firestore_1.where)('docType', '==', ''), (0, firestore_1.where)('deleted', '==', false)];

      if (options && options.espaceId) {
        constraints.push((0, firestore_1.where)('boutique', '==', options.espaceId));
      }

      constraints.push((0, firestore_1.orderBy)('createdAt', 'desc'));
      constraints.push((0, firestore_1.limit)(100));
      var q = (0, firestore_1.query).apply(void 0, [this.getCollectionRef()].concat(constraints));
      return (0, firestore_1.onSnapshot)(q, {
        next: function next(snapshot) {
          return _next(snapshot.docs.map(function (d) {
            return _objectSpread({
              id: d.id
            }, d.data());
          }));
        }
      });
    }
  }]);

  return Media;
}(Espace_1.default);

exports.default = Media;